import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import HttpApis from "../../services/HttpApis";
import { isPlausibleEmail as validateEmail } from "../../utils/validateEmail";
import { Notyf } from "notyf";
import "notyf/notyf.min.css";
import * as Styled from "../Login/style";
import { MdKeyboardArrowLeft } from "react-icons/md";

const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const notyf = new Notyf({ position: { x: "center", y: "center" } });


  useEffect(() => {
    const storedEmail = location.state?.email || localStorage.getItem("resetPasswordEmail");
    if (storedEmail) {
      setEmail(storedEmail);
    }
  }, [location]);

  useEffect(() => {
    const handlePopState = (e) => {
      e.preventDefault();
      window.history.pushState(null, '', window.location.pathname);
    };

    window.history.pushState(null, '', window.location.pathname);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleResetPasswordClick();
    }
  };

  const handleResetPasswordClick = async () => {
    if (loading) return;
    setError("");
    if (!email) {
      setError("Email cannot be empty");
      return;
    }
    if (!validateEmail(email)) {
      setError("Invalid email format");
      return;
    }
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("email", email);

      const response = await HttpApis.forgotPassowrd(formData);
      if (response.status === 200) {
        localStorage.setItem("resetPasswordEmail", email);
        notyf.success("An OTP has been sent to your registered email address");
        navigate("/forgotPassword", { state: { email: email }, replace: true });
      } else {
        setError("Failed to send password reset email");
      }
    } catch (err) {
      if (err.errors) {
        const errorMessages = Object.values(err.errors).flat();
        setError(errorMessages.join(', '));
      } else if (err.message) {
        setError(err.message);
      } else if (err.response?.data?.errors) {
        const errorMessages = Object.values(err.response.data.errors).flat();
        setError(errorMessages.join(', '));
      } else if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError("An error occurred. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Styled.LoginContainer>
      <Styled.MainContainer className="container">
        <div className="logo-container">
          <img src={`${process.env.PUBLIC_URL}/${process.env.REACT_APP_APP_LOGO}`}alt="Logo" className="logo" />
        </div>
        <div className="formContainer">
          <p className="para">Reset your password</p>
          <input
            placeholder="Enter your email"
            className="inputBox"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          {error && <p className="errorText">{error}</p>}
          <Button
            className="btn"
            onClick={handleResetPasswordClick}
            disabled={loading}
            style={{ backgroundColor: "var(--brand, #B87333)", borderColor: "var(--brand, #B87333)" }}
          >
            {loading ? "Sending…" : "Reset Password"}
          </Button>
        </div>
          <div className="paraText clickable" onClick={() => {
                  navigate("/Login")
                }} style={{ cursor: "pointer" }}>
                  <span><MdKeyboardArrowLeft className="arrowIcon" /></span> Go Back
                </div>
      </Styled.MainContainer>
    </Styled.LoginContainer>
  );
};

export default ResetPassword;
